import { Navigate, useLocation } from "react-router-dom";
import { useUserProfile } from "../contexts/UserProfileContext";

export default function AdminGate({ children }: { children: React.ReactNode }) {
  const { profile } = useUserProfile(); // falls du loading im Context hast
  const loc = useLocation();

  //if (loading) return <div className="p-6">Lade…</div>;
  if (!profile || profile.role !== "admin") {
    return (
      <Navigate to="/" replace state={{ from: loc.pathname, reason: "no-admin" }} />
    );
  }
  return <>{children}</>;
}
